export function getPreferredLanguage (supportedLocales = ['fr', 'en']) {
  const browserLocales = navigator.languages || [navigator.language || navigator.userLanguage]
  for (const locale of browserLocales) {
    const lang = locale.split('-')[0].toLowerCase()
    if (supportedLocales.includes(lang)) {
      return lang
    }
  }

  return 'en'
}
